import React from 'react';
import RootElement from './src/components/rootElement';
import './src/styles/global.css'

export const wrapRootElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};

// Ensure proper hydration for MDXEditor
export const onClientEntry = () => {
  // Set a flag to indicate we're on the client side
  if (typeof window !== 'undefined') {
    window.__GATSBY_HYDRATED__ = true;
  }
};
